import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const chatAPI = {
  sendMessage: async (message) => {
    const response = await api.post('/api/chat', { query: message });
    console.log('=== API 원본 응답 ===');
    console.log('response.data:', response.data);
    console.log('Keys:', Object.keys(response.data));
    return response;
  },
  getTraders: async () => {
    const response = await api.get('/api/traders');
    return response;
  },
  generateReport: async (traderId) => {
    const response = await api.post('/api/report', { trader_id: traderId });
    return response;
  },
  checkHealth: () => api.get('/api/health')
};

export default api;
